import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import {
  deleteReq,
  patch,
  useGet,
  usePatch,
  usePost,
} from "src/http-clients/clients";
import { getActiveStoreId } from "src/redux/selectors/app";

export const useCreateCourse = () => {
  const activeStore = useSelector(getActiveStoreId);
  return usePost(`/users/stores/${activeStore}/courses/create`);
};

export const useGetCourses = ({
  length,
  page,
  search,
}: {
  length?: number;
  page?: number;
  search?: string;
}) => {
  const activeStore = useSelector(getActiveStoreId);
  let offset;
  if (page && length) {
    offset = page === 1 ? 0 : (page - 1) * length;
  }
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(
    offset === undefined
      ? `/users/stores/${activeStore}/courses/list`
      : `/users/stores/${activeStore}/courses/list${queryData}`
  );
  return data;
};

export const useGetCourseData = (courseId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(
    courseId ? `/users/stores/${activeStore}/courses/${courseId}` : null
  );
};

export const useUpdateCourse = (courseId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return usePatch(`/users/stores/${activeStore}/courses/${courseId}`);
};

export const useDeleteCourse = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (courseId: number) => {
      return deleteReq(`/users/stores/${activeStore}/courses/${courseId}`);
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};

export const useUpdateCourseStatus = () => {
  const activeStore = useSelector(getActiveStoreId);
  const handleStatusChange = useCallback(
    (courseId: number, status: boolean) => {
      return patch(`/users/stores/${activeStore}/courses/${courseId}/status`, {
        status,
      });
    },
    [activeStore]
  );
  return useFetchAsync(handleStatusChange);
};
